import * as React  from 'react';
import { useState, useEffect, useRef } from "react";
import axios from 'axios';

const PER = 10;

const PurchaseHistory = (props) => {
  const [PurchaseHistories, setPurchaseHistories] = useState([]);
  const [marker, setMarker] = useState(PER);
  const [limit, setLimit] = useState(PER);
  const [OrderKbn, setOrderKbn] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isFetchedHistories, setIsFetchedHistories] = useState(false);
  const [hitoryTotalCount, setHistoryTotalCount] = useState(0);
  const createdAtFromRef = useRef(null);
  const createdAtToRef = useRef(null);

  useEffect(() => {
    async function fetchPurchaseHistories() {
      const PurchaseHistories = await axios.get(
        `/api/internal/tickets/data/purchase_history?search_created_at_from=${props.default_values.beginning_of_month}`
                                   + `&search_created_at_to=${props.default_values.end_of_month}`
                                   + `&limit=${PER}`,
      );
      setPurchaseHistories(PurchaseHistories.data.purchase_histories);
      setHistoryTotalCount(PurchaseHistories.data.history_total_count);
      setIsFetchedHistories(true);
    }
    fetchPurchaseHistories();
  }, []);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setIsDisabled(true);

    const createdAtFrom = createdAtFromRef.current ? createdAtFromRef.current.value : ''
    const createdAtTo = createdAtToRef.current ? createdAtToRef.current.value : ''
    axios.get(
      `/api/internal/tickets/data/purchase_history?order=${OrderKbn}`
                                  + `&search_created_at_from=${createdAtFrom}`
                                  + `&search_created_at_to=${createdAtTo}`
                                  + `&limit=${PER}`,
    ).then(function (response) {
      setPurchaseHistories(response.data.purchase_histories);
      setHistoryTotalCount(response.data.history_total_count);
      setMarker(PER);
    }).catch(function (error) {
    }).finally(() => {
      setIsDisabled(false);
    });
  }

  const loadList = () => {
    const createdAtFrom = createdAtFromRef.current ? createdAtFromRef.current.value : ''
    const createdAtTo = createdAtToRef.current ? createdAtToRef.current.value : ''
    // stateに即座に反映されないので一旦変数に入れてそっちを使う
    const newLimit = limit + PER
    setLimit(newLimit)

    axios.get(
      `/api/internal/tickets/data/purchase_history?order=${OrderKbn}`
                                  + `&search_created_at_from=${createdAtFrom}`
                                  + `&search_created_at_to=${createdAtTo}`
                                  + `&limit=${newLimit}`,
    ).then(function (response) {
      setPurchaseHistories(response.data.purchase_histories);
      setHistoryTotalCount(response.data.history_total_count);
    }).catch(function (error) {
    }).finally(() => {
      setMarker(marker + PER);
    });
  }

  const handleChangeOrder = (event) => {
    setOrderKbn(Number(event.target.value));
  }

  const onClickCsvDownload = () => {
    const createdAtFrom = createdAtFromRef.current ? createdAtFromRef.current.value : ''
    const createdAtTo = createdAtToRef.current ? createdAtToRef.current.value : ''
    const path = `/api/internal/tickets/data/download_csv.csv?order=${OrderKbn}`
                                             + `&search_created_at_from=${createdAtFrom}`
                                             + `&search_created_at_to=${createdAtTo}`;
    window.location.href = path;
  }

  return (
    <>
      <h3>チケット購入履歴</h3>
      <br/>
      <div className="panel panel-success">
        <div className="panel-heading">検索エリア</div>
        <div className="panel-body">
          <form name="searchForm" onSubmit={e => handleSearchSubmit(e)} acceptCharset="UTF-8">
            <input name="utf8" type="hidden" value="✓" />
            <div className="row">
              <div className="form-group col-sm-10 col-xs-12">
                <label>チケット購入年月日</label>
                <div className="form-inline">
                  <div className="pos_relative pull-left">
                    <input
                      type="text"
                      name="search_message_send_at_from"
                      className="form-control datepicker m5"
                      placeholder="検索日時(from)"
                      ref={createdAtFromRef}
                      defaultValue={props.default_values.beginning_of_month}
                    />
                  </div>
                  <div className="pos_relative pull-left m5">〜</div>
                  <div className="pos_relative pull-left">
                    <input
                      type="text"
                      name="search_message_send_at_to"
                      className="form-control datepicker m5"
                      placeholder="検索日時(to)"
                      ref={createdAtToRef}
                      defaultValue={props.default_values.end_of_month}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-3 col-xs-12">
                <label className="control-label" htmlFor="orderSelect">並び順</label>
                <select className="form-control" id="orderSelect" onChange={handleChangeOrder}>
                  {props.purchase_history_order_kbns.map((kbn, i) => (
                    <option value={kbn.value} key={i}>{kbn.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group col-sm-9 col-xs-12 text-right">
                <a onClick={onClickCsvDownload} className="btn btn-lg btn-primary mt30" style={{marginRight: '15px'}}>CSV出力</a>
                <input
                  type="submit"
                  name="button_search"
                  value="検索"
                  className="btn btn-lg btn-primary mt30"
                  disabled={isDisabled}
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="table-responsive">
        <table id="notice_table" className="table table-bordered table-hover">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center" style={{width: '16%'}}>企業名</th>
              <th scope="col" className="text-center" style={{width: '6%'}}>発行日/有効期限</th>
              <th scope="col" className="text-center" style={{width: '10%'}}>購入者</th>
              <th scope="col" className="text-center" style={{width: '16%'}}>チケット名</th>
              <th scope="col" className="text-center" style={{width: '4%'}}>購入数</th>
              <th scope="col" className="text-center" style={{width: '6%'}}>価格</th>
              <th scope="col" className="text-center" style={{width: '6%'}}>発行枚数</th>
              <th scope="col" className="text-center" style={{width: '6%'}}>消費枚数</th>
              <th scope="col" className="text-center" style={{width: '6%'}}>期限切れ枚数</th>
              <th scope="col" className="text-center" style={{width: '6%'}}>残り枚数</th>
            </tr>
          </thead>
          <tbody>
            {PurchaseHistories.map((purchase, i) => (
              <tr key={i}>
                <td className="text-center va_middle">{purchase.company_name}</td>
                <td className="text-center va_middle">{purchase.converted_created_at}<br />{purchase.converted_expired_at}</td>
                <td className="text-center va_middle">{purchase.purchase_user_name}</td>
                <td className="text-center va_middle">{purchase.ticket_name}</td>
                <td className="text-center va_middle">{purchase.set_count.toLocaleString()}</td>
                <td className="text-center va_middle">{purchase.price.toLocaleString()}円</td>
                <td className="text-center va_middle">{purchase.init_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{purchase.consumed_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{purchase.expired_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{purchase.remain_count.toLocaleString()}枚</td>
              </tr>
            )).slice(0, marker)}
          </tbody>
        </table>
        {
          hitoryTotalCount > marker
            ? <div className="text-center"><button className="btn btn-default more-btn" onClick={loadList}>もっと表示 ▼</button></div>
            : ''
        }
      </div>
    </>
  )
}

export default PurchaseHistory
